let menu = document.querySelector('.js-context-menu');
let filter = Array.prototype.filter;
let parents = function() {return document.querySelectorAll('.js-context-menu-parent');};
if (menu && parents) {
	parents().forEach(function(value, index, listObj) {
		value.addEventListener('click', toggleExpanded);
	});
	
	function toggleExpanded(event) {
		let item = event.target,
			parent = item.parentElement,
			child = item.nextElementSibling;
		if (child.classList.contains('hidden')) {
			let opened = filter.call(parents(), i => !!i.getAttribute('aria-expanded'));
			console.log(opened);
			opened.forEach(item => {
				item.setAttribute('aria-expanded', false);
				item.parentElement.classList.remove('opened');
				item.nextElementSibling.classList.add('hidden');
				item.nextElementSibling.setAttribute('aria-hidden', true);
			});
			child.classList.remove('hidden');
			item.setAttribute('aria-expanded', true);
			parent.classList.add('opened');
			child.setAttribute('aria-hidden', false);
		} else {
			child.classList.add('hidden');
			parent.classList.remove('opened');
			item.setAttribute('aria-expanded', false);
			child.setAttribute('aria-hidden', true);
		}
	}
}

function closeSiblings(element) {
	console.log();
}
